import React, { Component } from 'react'

function hexToRgb(hex) {
    const h = hex.replace('#', '')
    if (h.length === 3) {
        return {
            r: parseInt(h[0] + h[0], 16),
            g: parseInt(h[1] + h[1], 16),
            b: parseInt(h[2] + h[2], 16),
        }
    }
    return {
        r: parseInt(h.slice(0, 2), 16),
        g: parseInt(h.slice(2, 4), 16),
        b: parseInt(h.slice(4, 6), 16),
    }
}

function rgbToHex(r, g, b) {
    return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('')
}

function parseColor(value) {
    if (!value || value === 'transparent') return { hex: '#000000', alpha: 0 }
    const rgbaMatch = value.match(/rgba?\(\s*(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\s*\)/)
    if (rgbaMatch) {
        return {
            hex: rgbToHex(parseInt(rgbaMatch[1]), parseInt(rgbaMatch[2]), parseInt(rgbaMatch[3])),
            alpha: rgbaMatch[4] != null ? parseFloat(rgbaMatch[4]) : 1,
        }
    }
    if (value.startsWith('#')) {
        return { hex: value.slice(0, 7), alpha: 1 }
    }
    return { hex: '#000000', alpha: 1 }
}

function buildColor(hex, alpha) {
    if (alpha >= 1) return hex
    const { r, g, b } = hexToRgb(hex)
    return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(2)})`
}

class ColorInputWithTransparent extends Component {
    render() {
        const { value, onChange } = this.props
        const { hex, alpha } = parseColor(value)
        const alphaPercent = Math.round(alpha * 100)

        return (
            <div className="color-input-transparent">
                <input
                    type="color"
                    className="color-input-transparent__picker"
                    value={hex}
                    onChange={e => onChange(buildColor(e.target.value, alpha))}
                />
                <div className="color-input-transparent__alpha-wrap">
                    <input
                        type="range"
                        className="color-input-transparent__alpha"
                        min="0"
                        max="100"
                        value={alphaPercent}
                        onChange={e => onChange(buildColor(hex, parseInt(e.target.value, 10) / 100))}
                    />
                    <span className="color-input-transparent__alpha-label text-small-regular">
                        {alphaPercent}%
                    </span>
                </div>
            </div>
        )
    }
}

export default ColorInputWithTransparent
